export enum AllocationStatus {
    Open = 'Open',
    PatiallyClosed = 'Partially Closed',
    Rejected = 'Rejected',
    Closed = 'Closed',
    Processing = 'Processing'
}
